import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { User } from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-top-header',
  templateUrl: './top-header.component.html',
  styleUrls: ['./top-header.component.scss'],
})
export class TopHeaderComponent implements OnInit, OnDestroy {
  curentUser: User;

  logoutSub: Subscription;

  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.curentUser = this.authService.userValue;
  }

  onLogout() {
    // this.logoutSub =
    this.authService
      .logout()

      // ! Treba da se testira!
      .subscribe(() => {
        this.router.navigate(['/login']);
      });
  }

  ngOnDestroy() {
    // this.logoutSub.unsubscribe();
  }
}
